module.exports = __webpack_public_path__ + "img/4.a60362f4.jpg";